export enum USER_FIELD {
	USER='userId',
	DRIVER='mainDriverId',
	SECOND_DRIVER='additionalDriverId'
}
